<template>
  <v-form
    style="max-width: 800px"
    @submit.prevent="save"
    :disabled="loading"
  >
    <v-row class="mt-2">
      <!-- <v-col
        cols="12"
        sm="5"
        md="4"
        class="text-center pt-7"
      >
        <img
          v-if="user && user.fb_id"
          center
          style="width: 80px; height: 80px;border-radius: 40px;"
          :src="fbImageUrl"
        />
        <v-icon
          v-else
          style="font-size: 80px;"
          class="mb-4"
        >fa fa-user-circle</v-icon>

        <div>
          <v-btn
            v-if="!(user && user.fb_id)"
            color="primary"
            x-small
            @click="connectFacebook"
            :disabled="loading"
          >Connect With Facebook</v-btn>
        </div>
      </v-col> -->
      <v-col
        class="py-0"
      >
        <v-row class="mt-2">
          <v-col
            cols="12"
            sm="6"
            class="py-0"
          >
            <v-text-field
              label="First Name"
              :value="userChanged.firstname"
              @input="handleChange('user', 'firstname', $event)"
              :disabled="loading"
            />
          </v-col>
          <v-col
            cols="12"
            sm="6"
            class="py-0"
          >
            <v-text-field
              label="Last Name"
              :value="userChanged.lastname"
              @input="handleChange('user', 'lastname', $event)"
              :disabled="loading"
            />
          </v-col>
        </v-row>
        <v-text-field
          label="Email"
          type="email"
          :value="userChanged.email"
          @input="handleChange('user', 'email', $event)"
          :disabled="loading"
        />
        <v-checkbox
          :input-value="!!userChanged.drip_optin"
          label="I'd like to receive discounts and promotions by email"
          @click="handleChange('user', 'drip_optin', !userChanged.drip_optin)"
          :disabled="loading"
        />
        <!-- <v-text-field
          label="Change Password"
          :type="showPassword ? 'text' : 'password'"
          :value="user && user.password"
          @input="handleChange('user', 'password', $event)"
          :append-icon="showPassword ? 'fa-eye-slash' : 'fa-eye'"
          @click:append="showPassword = !showPassword"
        /> -->
      </v-col>
    </v-row>

    <div class="text-right">
      <v-btn
        v-if="user && user.id && allChanges.length"
        color="primary"
        type="submit"
        :disabled="loading"
      >Save</v-btn>
    </div>
  </v-form>
</template>

<script>
import { mapGetters } from 'vuex'
import { User } from '@/models'
import createChangeTrackerMixin from '@/mixins/createChangeTrackerMixin'
// import * as Facebook from 'fb-sdk-wrapper';

// const fbClientToken = '65404a400d12af4709414069972a3cd2'
// const fbAppId = '852735121406176'

export default {
  mixins: [
    createChangeTrackerMixin({ path: ['user'] })
  ],
  data () {
    return {
      loading: false,
      showPassword: false
    }
  },
  computed: {
    ...mapGetters(['user']),
    // fbImageUrl () {
    //   if (!(this.user && this.user.fb_id)) {
    //     return null
    //   }
    //   return `https://graph.facebook.com/${this.user.fb_id}/picture?type=large&breaking_change=profile_picture&access_token=${fbAppId}|${fbClientToken}`
    // }
  },
  async created () {
    this.loading = true
    try {
      // Facebook.load().then(() => {
      //   Facebook.init({
      //     appId: fbAppId
      //   })
      // })
      await User.fetchOne(this.user.id, { force: true })
    } finally {
      this.loading = false
    }
  },
  methods: {
    async save () {
      this.loading = true
      try {
        await User.save(this.userChanged)
        this.clearChanges()
        this.loading = false
      } catch (e) {
        this.loading = false
        throw e
      }
    },
  //   async connectFacebook () {
  //     let response = await Facebook.getLoginStatus()

  //     if (response.status !== 'connected') {
  //       response = await Facebook.login({
  //         scope: 'public_profile,email', //,user_birthday',
  //         return_scopes: true
  //       })
  //     }
  //     if (response && response.status === 'connected') {
  //       this.handleChange('user', 'fb_access_token', response.authResponse.accessToken)
  //       this.save()
  //     } else {
  //       console.warn('unable to connect')
  //     }
  //   }
  }
}
</script>